import React, { useState, useEffect } from "react";
import orderRoute from "../../services/orderRoute";
import { useAppContext } from "../../AppContext";
import { useNavigate } from "react-router-dom";
import { Card, Row, Col, Table } from "react-bootstrap";
import { AppVisitsOverTime, DashboardCharts } from "../../components/Charts/DashboardCharts";
import { getParsedLocalStorageItem } from "./AdminProfile";
import ArrowTrendChart from "../../components/Charts/ArrowLineChart";

const AdminReports = () => {
  const userData = getParsedLocalStorageItem("userData");
  const { showToast } = useAppContext();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { getLatestOrders, getOrderOverviewData } = orderRoute();
  const [latestOrders, setLatestOrders] = useState([]);
  const [orderOverviewDetails, setOrderOverviewDetails] = useState([]);

  useEffect(() => {
    getLatestOrders(setLoading, showToast, setLatestOrders);
    getOrderOverviewData(setLoading, setOrderOverviewDetails, showToast);
  }, []);
  const capitalizeFirstLetter = (string) => {
    return string?.replace(/\b(\w)/g, (s) => s?.toUpperCase());
  };
  const getStatusStyle = (status) => {
    switch (status) {
      case "order confirmed":
        return {
          backgroundColor: "white",
          color: "#194298",
          border: "1px solid #194298",
          padding: "6px 16px 6px 16px",
          borderRadius: "16px",
        };
      case "order delivered":
        return {
          backgroundColor: "white",
          color: "#08875D",
          border: "1px solid #08875D",
          padding: "6px 16px 6px 16px",
          borderRadius: "16px",
        };
      case "order picked up":
        return {
          backgroundColor: "white",
          color: "#08875D",
          border: "1px solid #08875D",
          padding: "6px 16px 6px 16px",
          borderRadius: "16px",
        };
      case "out for delivery":
        return {
          backgroundColor: "white",
          color: "#F2994A",
          border: "1px solid #F2994A",
          padding: "6px 16px 6px 16px",
          borderRadius: "16px",
        };
      case "ready for pickup":
        return {
          backgroundColor: "white",
          color: "#F2994A",
          border: "1px solid #F2994A",
          padding: "6px 16px 6px 16px",
          borderRadius: "16px",
        };
      case "order processing":
        return {
          backgroundColor: "white",
          color: "#B25E09",
          border: "1px solid #B25E09",
          padding: "6px 16px 6px 16px",
          borderRadius: "16px",
        };
      case "awaiting payment":
        return {
          backgroundColor: "white",
          color: "#FD7B1D",
          padding: "6px 16px 6px 16px",
          borderRadius: "16px",
          border: "1px solid #FD7B1D",
        };
      default:
        return {
          backgroundColor: "white",
          color: "#B25E09",
          border: "1px solid #FEF1F2",
          padding: "6px 16px 6px 16px",
          borderRadius: "16px",
        };
    }
  };

  const determineStatus = (order) => {
    let statusText = "Status Unknown";
    let statusStyle = { backgroundColor: "grey", color: "white" };

    if (Array.isArray(order?.orderInfo) && order?.orderInfo.length > 0) {
      const lastStatusObj = order?.orderInfo[order?.orderInfo.length - 1];
      statusText = capitalizeFirstLetter(lastStatusObj?.orderStatus);
    } else if (order?.paymentStatus === "pending") {
      statusText = "Awaiting Payment";
    } else if (order?.source === "voucher") {
      statusText = "Order Confirmed";
    }

    statusStyle = getStatusStyle(statusText?.toLowerCase());
    return <span style={statusStyle}>{statusText}</span>;
  };

  const truncateText = (text, maxLength = 20) => {
    return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
  };
  if (!orderOverviewDetails) return null;

  const stats = [
    {
      title: "Products Sold",
      value: orderOverviewDetails?.products?.productsSold,
      change: orderOverviewDetails?.products?.productsSoldPercentageChange,
    },
    {
      title: "Total Revenue",
      value: orderOverviewDetails?.revenue?.totalRevenue,
      change: orderOverviewDetails?.revenue?.totalRevenuePercentageChange,
    },
    {
      title: "Total Orders",
      value: orderOverviewDetails?.orders?.totalOrders,
      change: orderOverviewDetails?.orders?.totalOrdersPercentageChange,
    },
    {
      title: "Customers",
      value: orderOverviewDetails?.customers?.totalCustomers,
      change: orderOverviewDetails?.customers?.totalCustomersPercentageChange,
    },
  ];

  return (
    <main className=" pe-5 ps-4 ">
      <div className="d-flex gap-3 align-items-center header-admin  mb-4">
        <h3 style={{ color: "#344054" }} className="my-auto">
          {" "}
          Report Overview
        </h3>
      </div>
      <section>
        <h5 style={{ fontWeight: "500" }}>Welcome {userData?.firstName},</h5>
        {loading ? (
          <div
            className="justify-content-center align-items-center text-center"
            style={{ padding: "100px" }}
          >
            <div className="spinner-border text-success" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : Object.keys(orderOverviewDetails)?.length > 0 ? (
          <Row className="justify-content-center my-4 gap-3 ">
            {stats.map((stat, index) => {
              const color = stat?.color;
              const percentage = stat?.change;

              return (
                <Col key={index} className="mb-3 w-100">
                  <Card
                    className="text-center shadow-sm border-0 d-flex flex-column h-100 m-0 "
                    style={{ background: "#469B120D" }}
                  >
                    <Card.Body className="d-flex flex-column justify-content-between h-100 py-3 px-2 m-0 ">
                      <div className="d-flex flex-column">
                        {/* Left */}
                        <div className="d-flex justify-content-between">
                          <p style={{ color: "#33333380", fontWeight: "500" }}>{stat.title}</p>
                          <span
                            style={{
                              color,
                              fontWeight: "bold",
                              fontSize: "0.9rem",
                            }}
                          >
                            {percentage > 0 ? "+" : ""}
                            {percentage !== 0 ? percentage.toFixed(0) : "0"}%
                          </span>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                          <h5 className="fw-bold ">{stat.value.toLocaleString()}</h5>
                          <ArrowTrendChart change={stat.change} />
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              );
            })}
          </Row>
        ) : (
          <div className="fw-medium px-5 py-5 ">
            <h4>You have no data</h4>
          </div>
        )}
        <div className="px-3">
          <DashboardCharts />
          <AppVisitsOverTime />
        </div>
        {loading ? (
          <div
            className="justify-content-center align-items-center text-center"
            style={{ padding: "100px" }}
          >
            <div className="spinner-border text-success" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : latestOrders?.length > 0 ? (
          <div
            style={{
              boxShadow: "0px 8px 32px 0px #3326AE14",
              backgroundColor: "#FFFFFF",
              borderRadius: "16px",
            }}
            className="p-4 my-4"
          >
            <h4 style={{ fontWeight: "500" }}>Latest Orders</h4>
            <Table hover className="my-4">
              <thead>
                <tr style={{ fontWeight: "600" }} className="mb-2">
                  <th style={{ fontWeight: "600" }} className="pb-3">
                    Order ID
                  </th>
                  <th style={{ fontWeight: "600" }} className="pb-3">
                    Customer Name
                  </th>
                  <th style={{ fontWeight: "600" }} className="pb-3">
                    {" "}
                    Price
                  </th>
                  <th style={{ fontWeight: "600" }} className="pb-3">
                    Delivery LGA
                  </th>
                  <th style={{ fontWeight: "600" }} className="pb-3">
                    Payment Method
                  </th>
                  <th style={{ fontWeight: "600" }} className="pb-3">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody className="py-2">
                {latestOrders?.map((order) => (
                  <tr
                    style={{
                      fontSize: "14px",
                      fontWeight: "400",
                      color: "#333333",
                      paddingTop: "15px",
                      paddingBottom: "15px",
                    }}
                    key={order?._id}
                  >
                    <td
                      style={{
                        paddingTop: "15px",
                        paddingBottom: "15px",
                        color: "#597CC4",
                        cursor: "pointer",
                        textDecoration: "underline",
                        fontWeight: "500",
                      }}
                      onClick={() => navigate(`/admin/orders/${order?._id}`)}
                    >
                      {truncateText(`${order?.sku ? order?.sku : order?._id}`)}
                    </td>
                    {order?.user ? (
                      <td
                        style={{
                          paddingTop: "15px",
                          paddingBottom: "15px",
                        }}
                      >
                        {order?.user?.firstName}&nbsp;{order?.user?.lastName}
                      </td>
                    ) : (
                      <td style={{ paddingTop: "15px", paddingBottom: "15px" }}>
                        {order?.metaData?.userName}
                      </td>
                    )}

                    <td style={{ paddingTop: "15px", paddingBottom: "15px" }}>
                      {order?.totalCost?.toLocaleString() || order?.amount?.toLocaleString()}
                    </td>
                    <td style={{ paddingTop: "15px", paddingBottom: "15px" }}>
                      {order?.deliveryType === "delivery" &&
                      order?.address &&
                      Object.keys(order?.address)?.length > 0
                        ? capitalizeFirstLetter(
                            `${order?.address?.city?.name ? `${order?.address?.city?.name}, ` : ""}${order?.address?.state?.name}`
                          )
                        : order?.deliveryType === "pickup"
                          ? "In-store pickup"
                          : "Gift Voucher"}
                    </td>
                    <td style={{ paddingTop: "15px", paddingBottom: "15px" }}>
                      {capitalizeFirstLetter(order.paymentMethod)}
                    </td>
                    <td style={{ paddingTop: "15px", paddingBottom: "15px" }}>
                      {determineStatus(order)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        ) : (
          <div className="fw-medium px-5 py-5 ">
            <h4>You have no orders</h4>
          </div>
        )}
      </section>
    </main>
  );
};

export default AdminReports;
